<!--     Contact Us      -->
<div class="contactus-1 section-image">
    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <h2 class="title">Ready to Become a Partner?</h2>
          <h5 class="description">We need your help to make continuous compliance automation a reality.  Contact us today to help our customers bring DevOps to Compliance.</h5>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="material-icons">pin_drop</i>
            </div>
            <div class="description">
              <h4 class="info-title">Find us at our HQ</h4>
              <p> RegScale, Inc.
                <br> 1775 Tysons Boulevard, Fifth Floor
                <br> Tysons, VA 22102
              </p>
            </div>
          </div>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="material-icons">pin_drop</i>
            </div>
            <div class="description">
              <h4 class="info-title">Find us at our R&D Office</h4>
              <p> RegScale, Inc.
                <br> 2704 Cherokee Farm Way, Suite 204
                <br> Knoxville, TN 37920
              </p>
            </div>
          </div>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="material-icons">phone</i>
            </div>
            <div class="description">
              <h4 class="info-title">Give us a ring</h4>
              <p> RegScale Sales
                <br> 202-991-7881
                <br> Mon - Fri, 8:00 AM - 5:00 PM ET
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-5 ml-auto">
          <div class="card card-contact">
            <form #f="ngForm" data-toggle="validator" novalidate="true">
              <div class="card-header card-header-raised card-header-info text-center">
                <h4 class="card-title">Partner Registration</h4>
              </div>
              <div class="card-body">
                <iframe src="https://go.regscale.com/l/999611/2022-11-07/296h" width="100%" height="1000" type="text/html" frameborder="0" allowTransparency="true" style="border: 0" scrolling="no"></iframe>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
   </div>

